import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Menu from './module/menu'
import Footer from './module/footer'
import Content from './module/content'
import Documentation from './module/documentation'

class App extends React.Component {
  render(){
    return(
    <div className="App">
      <Router>
        <Route exact path="/" render={() =>{
          return <div>
          <Menu />
          <Content />
          <Footer />
          </div>
        }}></Route>

        <Route exact path="/documentation" render={() =>{
          return <div>
          <Menu />
          <Documentation />
          </div>
        }}></Route>
      </Router>
    </div>
    )
  };
}

export default App;